import { defineMessage, type IntlShape, type MessageDescriptor } from "react-intl";
import { Ar, io, Ord, pipe } from "../prelude";

const genderOrder = {
  T: 0,
  F: 1,
  M: 2,
};

export const Gender = io.keyof(genderOrder);
export type Gender = io.TypeOf<typeof Gender>;

export const getGenderIndex = (k: Gender) => genderOrder[k];

export const ordGender = Ord.contramap((gender: Gender) => getGenderIndex(gender))(Ord.ordNumber);

const genderLookup: Record<Gender, MessageDescriptor> = {
  T: defineMessage({ id: "Total", defaultMessage: "Total" }),
  F: defineMessage({ id: "Female", defaultMessage: "Female" }),
  M: defineMessage({ id: "Male", defaultMessage: "Male" }),
};
export const getGenderName = (intl: IntlShape, gender: Gender) => intl.formatMessage(genderLookup[gender]);

export function sortGenders<A>(xs: Array<A>, get: (x: A) => Gender) {
  return pipe(xs, Ar.sort(Ord.contramap((needle: A) => get(needle))(ordGender)));
}
